import { useMemo, useEffect } from "react";
import { useTranslations } from 'next-intl';
import { inject, observer } from "mobx-react";
import MobileVariationSelector from "./MobileVariationSelector";
import MobileVariationToggle from "./MobileVariationToggle";

const MobileVariationSelect = inject('studioStore')(observer(({
  studioStore,
  productType,
  product,
  selectedVariation,
  setSelectedVariation,
  handleVariationChange,
  productDisplayType,
}) => {
  // Memoize published variations to avoid recalculating on every render
  const publishedVariations = useMemo(() => {
    return product?.variations?.filter(variation => variation.status === "publish") || [];
  }, [product?.variations]);

  useEffect(() => {
    if (productType === "variable" && !selectedVariation && publishedVariations.length > 0) {
      setSelectedVariation(publishedVariations[0]); // Set the first published variation by default
    }
  }, [productType, publishedVariations, selectedVariation, setSelectedVariation]);

  const t = useTranslations('Product');
  const cartDesign = studioStore?.cart;

  return (
    <div className="min-w-[5.65rem] mt-3 md:hidden">
      {productType === "variable" && publishedVariations.length !== 1 ? (
        <>
          {publishedVariations.length === 2 && (
            <MobileVariationToggle
              product={product}
              selectedVariation={selectedVariation}
              setSelectedVariation={setSelectedVariation}
            />
          )}
          {publishedVariations.length > 2 && (
            <MobileVariationSelector
              product={{ ...product, variations: publishedVariations }}
              selectedVariation={selectedVariation}
              handleVariationChange={handleVariationChange}
              t={t}
            />
          )}
        </>
      ) : productDisplayType ? (
        <div className="flex justify-evenly items-center text-black space-x-1 max-w-[10rem]">
          <span
            className={`${cartDesign?.product?.border_radius} w-20 py-1 text-sm text-center text-primary-studio bg-primary-light-studio font-secondary`}
          >
            {productDisplayType}
          </span>
        </div>
      ) : null}
    </div>
  );
}));

export default MobileVariationSelect;
